import React, { useMemo } from "react";

const limpiarHtmlExterno = (html) => {
  if (!html) return "";

  const documento = new DOMParser().parseFromString(
    String(html),
    "text/html"
  );

  /*
   * Eliminamos recursos que pueden modificar los estilos
   * globales de toda la aplicación.
   */
  documento
    .querySelectorAll(
      'link[rel="stylesheet"], style, script, meta, base, title'
    )
    .forEach((elemento) => elemento.remove());

  /*
   * Devolvemos solamente el contenido del body.
   * Las etiquetas html, head y body del documento original
   * no deben insertarse dentro de la aplicación.
   */
  return documento.body.innerHTML;
};

const Html = ({
  data,
  campokey,
  id_elemento
}) => {
  const htmlLimpio = useMemo(() => {
    return limpiarHtmlExterno(data?.[campokey]);
  }, [data, campokey]);

  return (
    <div
      data-component="html_container"
      id={id_elemento}
      dangerouslySetInnerHTML={{
        __html: htmlLimpio
      }}
    />
  );
};

export default Html;